import AppBar from "@material-ui/core/AppBar";
import Tab from "@material-ui/core/Tab";
import TabList from "@material-ui/lab/TabList";
import TabPanel from "@material-ui/lab/TabPanel";
import { withStyles } from "@material-ui/styles";
import { theme } from "styles/theme";

export const StyledAppBar = withStyles({
    root: {
        margin: "0 -24px",
        width: "auto",
        padding: "0 24px",
        boxShadow: "none",
        backgroundColor: "white",
    },
})(AppBar);

export const StyledTabs = withStyles({
    root: {
        minHeight: "35px",
    },
    indicator: {
        backgroundColor: theme.palette.accent1Color,
    },
    flexContainer: {
        justifyContent: "center",
    },
})(TabList);

export const StyledTab = withStyles({
    root: {
        padding: "0 12px 6px",
        minHeight: "35px",
        fontFamily: "'Lato', sans-serif",
    },
})(Tab);

export const StyledTabPanel = withStyles({
    root: {
        padding: "24px 0 0",
        minHeight: "120px",
    },
})(TabPanel);
